import { css } from 'lit';

export const tabItemOnDarkStyles = css` 

    --_tab__color: var(--sbkTabColorFgColorOnDarkEnabled);
    --_tab__color--hover: var(--sbkTabColorFgColorOnDarkHover);
    --_tab__color--active: var(--sbkTabColorFgColorOnDarkActive);
    --_tab__br--focus: var(--sbkTabBorderOnDarkFocus);
  
 
`;